import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
// import ListItemAvatar from '@mui/material/ListItemAvatar';
// import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';

import AddIcon from '@mui/icons-material/Add';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';

function ManageLayoutItem(props) {
  const { t } = useTranslation('maintenance');

  const {
    loading,
    disabled,
    data,
    dataType,
    addLayoutItem,
    selectedData,
    handleChangeData,
    changeEnabled,
  } = props;

  return (
    <Box>
      {dataType !== 'equipment' ? t('select_extisting_or_add_new') : null}
      <Button
        variant="contained"
        sx={{
          // width: '40%',
          // height: '90px',
          color: 'primary.contrastText',
          backgroundColor: 'success.main',
          ':hover': {
            color: 'primary.contrastText',
            backgroundColor: 'success.dark',
          },
        }}
        onClick={() => addLayoutItem(dataType)}
        disabled={loading || disabled}
        startIcon={
          !loading ? (
            <AddIcon />
          ) : (
            <CircularProgress color="inherit" size={20} />
          )
        }
      >
        {t('add_new')}
      </Button>
      <TableContainer component={Paper} sx={{ mt: 1, maxHeight: '300px' }}>
        <Table
          stickyHeader
          sx={{
            //   borderCollapse: 'separate',
            width: '100%',
            tableLayout: 'fixed',
            '.MuiTableCell-head': {
              backgroundColor: 'primary.light',
              color: '#000000',
              fontWeight: 'bold',
            },
            '.MuiTableCell-root': {
              px: '2px',
              py: 0,
              // px: '4px',
              // py: '2px',
              // fontSize: '10px',
            },
          }}
          size="small"
        >
          <TableHead>
            <TableRow>
              {dataType !== 'equipment' ? (
                <TableCell variant="head" sx={{ width: '50px' }} />
              ) : null}
              <TableCell variant="head">{t(dataType)}</TableCell>
              <TableCell variant="head" align="right">
                {t('common:enabled')}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((x) => (
              <TableRow
                key={x?.id}
                sx={{
                  '&:nth-of-type(odd)': {
                    backgroundColor: 'action.hover',
                  },
                  '&:nth-of-type(even)': {
                    backgroundColor: 'action.selected',
                  },
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                {dataType !== 'equipment' ? (
                  <TableCell>
                    {/* <Button
                        variant="contained"
                        //   onChange={handleToggle(value)}
                        disabled={loading || disabled}
                      >
                        Select
                      </Button> */}
                    <IconButton
                      onClick={() => handleChangeData(x?.id)}
                      disabled={loading || disabled}
                    >
                      <ArrowCircleRightOutlinedIcon
                        disabled
                        sx={{
                          // width: '40%',
                          // height: '90px',
                          color: loading
                            ? 'disabled'
                            : selectedData === x?.id
                            ? 'primary.main'
                            : 'text.primary',
                        }}
                      />
                    </IconButton>
                  </TableCell>
                ) : null}
                <TableCell component="th" scope="row">
                  <Typography
                    // variant="body2"
                    sx={{
                      color:
                        selectedData === x?.id
                          ? 'primary.main'
                          : 'text.primary',
                      display: '-webkit-box',
                      WebkitLineClamp: '2',
                      lineClamp: '2',
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      wordBreak: 'break-word',
                    }}
                  >
                    {x[dataType + 'Name']}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Checkbox
                    onChange={(event) =>
                      changeEnabled(dataType, x?.id, event.target.checked)
                    }
                    checked={x?.enabled}
                    inputProps={{ 'aria-labelledby': `data-label-${x?.id}` }}
                    disabled={loading || disabled}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

ManageLayoutItem.propTypes = {
  loading: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  dataType: PropTypes.string.isRequired,
  addLayoutItem: PropTypes.func.isRequired,
  selectedData: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  handleChangeData: PropTypes.func.isRequired,
  changeEnabled: PropTypes.func.isRequired,
};

export default ManageLayoutItem;
